import moment from 'moment';
import appStore from 'store';
import api from './api';
import math from '../../common/math';
import { Message } from 'element-ui';

const store = {
  namespaced: true,
  state: {
    statistics: [],
    netFlows: [],
  },
  mutations: {
    setStatistics(state, payload) {
      state.statistics = payload;
    },
    setNetFlows(state, payload) {
      state.netFlows = payload;
    }
  },
  getters: {
    statisticsSnapshotTimes: state => state.statistics[0] && state.statistics[0].data.map(d => moment(d.snapshotTime).format('YYYY-MM-DD HH:mm')),
    formattedStatistics: (state, getters) => {
      const coinSeries = state.statistics.reduce((arr, item) => {
        return arr.concat({
          name: item.coinType,
          type: 'line',
          smooth: true,
          data: item.data.map(d => +d.amount)
        })
      }, [])
      const flowSeries = state.statistics.reduce((arr, item) => {
        const data = item.data.map((d, i) => {
          const current = d.snapshotTime;
          const last = (item.data[i - 1] && item.data[i - 1].snapshotTime) || 0;
          const matched = state.netFlows.filter(nf => item.coinType === nf.coinType && (nf.businessTime > last) && (nf.businessTime <= current)).reduce((r, nf) => math.add(r, nf.amount), 0)
          return matched;
        })
        const result = {
          name: item.coinType + '净流入流出',
          type: 'bar',
          // yAxisIndex: 1,
          data: data
        }
        return arr.concat(result);

      }, [])

      const coinSeriesWithoutFlow = state.statistics.reduce((arr, item, i) => {
        return arr.concat({
          name: item.coinType + '扣除净流入流出',
          type: 'line',
          smooth: true,
          hide: true,
          data: item.data.map((d, j) => {
            const matchedFlow = flowSeries[i] && flowSeries[i].data && flowSeries[i].data.reduce((n, item, k) => k <= j ? math.add(n, item) : n, 0) || 0;
            return math.subtract(d.amount, matchedFlow);
          })
        })
      }, [])
      return coinSeries.concat(coinSeriesWithoutFlow).concat(flowSeries);
    },
    formattedPriceStatistics: (state, getters) => {
      return state.statistics.reduce((arr, item) => {
        if (item.coinType === 'USDT') return arr;
        return arr.concat({
          name: item.coinType + '_USDT 价格',
          type: 'line',
          smooth: true,
          data: item.data.map(d => +d.priceToUSDT)
        })
      }, [])
    },
    formattedCostingStatistics: state => {
      const dataExchange = state.statistics[0] && state.statistics[0].data;
      const dataAnchor = state.statistics[1] && state.statistics[1].data;
      if (!dataExchange || !dataAnchor) return [];
      const costing = dataExchange && dataExchange.map((item, i) => {
        if (i === 0) return null;
        if (!dataExchange[i] || !dataExchange[0]) return null;
        if (!dataAnchor[i] || !dataAnchor[0]) return null;
        else {
          const current = dataExchange[i].snapshotTime;

          const matchedStart0 = state.netFlows.filter(nf => state.statistics[0].coinType === nf.coinType && (nf.businessTime <= dataExchange[0].snapshotTime)).reduce((r, nf) => math.add(r, nf.amount), 0);
          const matchedStart1 = state.netFlows.filter(nf => state.statistics[1].coinType === nf.coinType && (nf.businessTime <= dataExchange[0].snapshotTime)).reduce((r, nf) => math.add(r, nf.amount), 0);

          const matched0 = state.netFlows.filter(nf => state.statistics[0].coinType === nf.coinType && (nf.businessTime <= current)).reduce((r, nf) => math.add(r, nf.amount), 0);
          const matched1 = state.netFlows.filter(nf => state.statistics[1].coinType === nf.coinType && (nf.businessTime <= current)).reduce((r, nf) => math.add(r, nf.amount), 0);

          let change0 = math.subtract(math.subtract(dataExchange[i].amount, matched0), math.subtract(dataExchange[0].amount, matchedStart0));

          let change1 = math.subtract(math.subtract(dataAnchor[0].amount, matchedStart1), math.subtract(dataAnchor[i].amount, matched1));


          if (change0 === 0) return null;
          return Number(Math.abs(math.divide(change1, change0)).toFixed(8)) || null;
        }
      });

      let profit = [];
      try {


        profit = dataExchange && dataExchange.map((item, i) => {
          if (i === 0) return null;
          if (!dataExchange[i] || !dataExchange[0]) return null;
          if (!dataAnchor[i] || !dataAnchor[0]) return null;
          else {
            const current = dataExchange[i].snapshotTime;

            const matchedStart0 = state.netFlows.filter(nf => state.statistics[0].coinType === nf.coinType && (nf.businessTime <= dataExchange[0].snapshotTime)).reduce((r, nf) => math.add(r, nf.amount), 0);
            const matchedStart1 = state.netFlows.filter(nf => state.statistics[1].coinType === nf.coinType && (nf.businessTime <= dataExchange[0].snapshotTime)).reduce((r, nf) => math.add(r, nf.amount), 0);


            const matched0 = state.netFlows.filter(nf => state.statistics[0].coinType === nf.coinType && (nf.businessTime <= current)).reduce((r, nf) => math.add(r, nf.amount), 0);

            const matched1 = state.netFlows.filter(nf => state.statistics[1].coinType === nf.coinType && (nf.businessTime <= current)).reduce((r, nf) => math.add(r, nf.amount), 0);

            let change0 = math.subtract(math.subtract(dataExchange[i].amount, matched0), math.subtract(dataExchange[0].amount, matchedStart0));

            let change1 = math.subtract(math.subtract(dataAnchor[0].amount, matchedStart1), math.subtract(dataAnchor[i].amount, matched1));

            if (!dataExchange[i].priceToUSDT) {
              throw new Error('无法获取到' + state.statistics[0].coinType + '对USDT价格,利润计算失败');
            }
            else if (!dataAnchor[i].priceToUSDT) {
              throw new Error('无法获取到' + state.statistics[1].coinType + '对USDT价格,利润计算失败');
            } else {
              const change0ToChange1 = math.divide(math.multiply(change0, dataExchange[i].priceToUSDT), dataAnchor[i].priceToUSDT);
              return Number(math.subtract(change0ToChange1, change1).toFixed(8)) || null;
            }

          }

        });
      } catch (e) {
        Message.error({ message: e.message });
        profit = [];
      }


      return [{
        name: '成本',
        type: 'line',
        smooth: true,
        data: costing
      }, {
        name: '利润',
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        data: profit
      }]
    }
  },
  actions: {
    getStatistics({ commit }, { from, to, userIds, pair }) {
      api.getStatistics({ from, to, userIds, pair }).then(({ data }) => {
        commit('setStatistics', data);
      });
    },
    listFlow({ commit }, { from, to, userIds, pair }) {
      api.listFlow({ from, to, userIds, coinTypes: pair.split('_').join(',') }).then(({ data }) => {
        commit('setNetFlows', data);
      });
    },
    createFlow({ commit }, { time, userId, coinType, amount }) {
      return api.createFlow({ time, userId, coinType, amount });
    },
    removeFlow({ commit }, { id }) {
      return api.removeFlow({ id });
    }
  }
};

appStore.registerModule('snapshotStatistic', store);
